import { render, staticRenderFns } from "./LoadMsp.vue?vue&type=template&id=01c0453c"
import script from "./LoadMsp.vue?vue&type=script&lang=js"
export * from "./LoadMsp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports